import axios from "axios";

const baseUrl = `${process.env.REACT_APP_API_URL}/api`;
const token = localStorage.getItem("token");

/// ===========================
/// 📦 VOTES
/// ===========================

// ✅ GET - Tous les votes
export const getAllVotes = async () => {
  try {
    const response = await axios.get(`${baseUrl}/vote/all`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    if (response.status !== 200) throw new Error("Erreur de récupération");
    return response.data;
  } catch (error) {
    console.error("Erreur lors du chargement des votes :", error);
    return [];
  }
};

// ✅ GET - Un vote par ID
export const getVoteById = async (id) => {
  try {
    const response = await axios.get(`${baseUrl}/vote/${id}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    if (response.status !== 200) throw new Error("Erreur de récupération");
    return response.data;
  } catch (error) {
    console.error("Erreur lors du chargement du vote :", error);
    return null;
  }
};

// ✅ GET - Résultats d’un vote
export const getVoteResults = async (voteId) => {
  try {
    const response = await axios.get(`${baseUrl}/vote/${voteId}/results`);
    return response.data;
  } catch (error) {
    console.error("Erreur récupération résultats vote :", error);
    return null;
  }
};

// ✅ POST - Créer un vote
export const createVote = async (voteData) => {
  try {
    const response = await axios.post(`${baseUrl}/vote/create`, voteData, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Erreur lors de la création du vote :", error);
    return null;
  }
};

// ✅ PUT - Modifier un vote
export const updateVote = async (id, updatedData) => {
  try {
    const response = await axios.put(
      `${baseUrl}/vote/update/${id}`,
      updatedData,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Erreur lors de la mise à jour du vote :", error);
    return null;
  }
};

// ✅ DELETE - Supprimer un vote
export const deleteVote = async (id) => {
  try {
    const response = await axios.delete(`${baseUrl}/vote/delete/${id}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Erreur lors de la suppression du vote :", error);
    return null;
  }
};

/// ===========================
/// ❓ QUESTIONS
/// ===========================

// ✅ POST - Ajouter une question à un vote
export const addQuestionToVote = async (voteId, questionData) => {
  try {
    const response = await axios.post(
      `${baseUrl}/vote/${voteId}/questions`,
      questionData,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Erreur lors de l'ajout de la question :", error);
    return null;
  }
};

// ✅ PUT - Modifier une question
export const updateQuestion = async (questionId, updatedData) => {
  try {
    const response = await axios.put(
      `${baseUrl}/question/update/${questionId}`,
      updatedData,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Erreur lors de la mise à jour de la question :", error);
    return null;
  }
};

// ✅ DELETE - Supprimer une question
export const deleteQuestion = async (questionId) => {
  try {
    const response = await axios.delete(
      `${baseUrl}/question/delete/${questionId}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Erreur lors de la suppression de la question :", error);
    return null;
  }
};

/// ===========================
/// ✅ CHOICES (réponses)
/// ===========================

// ✅ POST - Ajouter un choix à une question
export const addChoiceToQuestion = async (questionId, choiceData) => {
  try {
    const response = await axios.post(
      `${baseUrl}/question/${questionId}/choices`,
      choiceData,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Erreur lors de l'ajout du choix :", error);
    return null;
  }
};

// ✅ PUT - Modifier un choix
export const updateChoice = async (choiceId, updatedData) => {
  try {
    const response = await axios.put(
      `${baseUrl}/choice/update/${choiceId}`,
      updatedData,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Erreur lors de la mise à jour du choix :", error);
    return null;
  }
};

// ✅ DELETE - Supprimer un choix
export const deleteChoice = async (choiceId) => {
  try {
    const response = await axios.delete(
      `${baseUrl}/choice/delete/${choiceId}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Erreur lors de la suppression du choix :", error);
    return null;
  }
};

/// ===========================
/// 🧾 BALLOTS (Soumission de vote)
/// ===========================

// ✅ POST - Soumettre un vote (token + réponses)
export const submitVote = async (votePayload) => {
  try {
    const response = await axios.post(`${baseUrl}/vote/submit`, votePayload, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Erreur lors de la soumission du vote :", error);
    return null;
  }
};

/// ✅ GET - Récupérer les réponses d'un utilisateur
export const getUserBallots = async (userId) => {
  try {
    const response = await axios.get(`${baseUrl}/vote/ballots/${userId}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data; // [{ vote_id, responses }]
  } catch (error) {
    console.error("Erreur lors du chargement des réponses :", error);
    return [];
  }
};

/// GET Récupérer la réponse d'un utilisateur sur un vote
export const getUserBallotsForVote = async (userId, voteId) => {
  try {
    const response = await axios.get(
      `${baseUrl}/vote/ballots/${userId}/by-vote/${voteId}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data; // [{ vote_id, responses }]
  } catch (error) {
    console.error("Erreur lors du chargement des réponses :", error);
    return [];
  }
};

/// ===========================
/// 🔐 TOKENS d'invitation
/// ===========================

// ✅ POST - Générer des tokens d'invitation pour un vote
export const generateTokens = async (voteId, users) => {
  try {
    const response = await axios.post(
      `${baseUrl}/vote/${voteId}/generate-tokens`,
      { users },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data; // [{ email, club_name, token }]
  } catch (error) {
    console.error("Erreur lors de la génération des tokens :", error);
    return [];
  }
};

// ✅ GET - Vérifier la validité d’un token
export const checkToken = async (token) => {
  try {
    const response = await axios.get(`${baseUrl}/vote/check-token/${token}`);
    return response.data; // { valid: true/false, vote_id, club_name }
  } catch (error) {
    console.error("Erreur lors de la vérification du token :", error);
    return { valid: false };
  }
};

// ✅ GET - Récupérer les tokens d’un vote
export const getVoteTokens = async (voteId) => {
  try {
    const response = await axios.get(`${baseUrl}/vote/${voteId}/tokens`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Erreur lors du chargement des tokens :", error);
    return [];
  }
};

// ✅ DELETE - Supprimer un token
export const deleteToken = async (tokenId) => {
  try {
    const response = await axios.delete(
      `${baseUrl}/vote/token/delete/${tokenId}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Erreur lors de la suppression du token :", error);
    return null;
  }
};
